export default __webpack_public_path__ + "static/media/qr-box-link.66024be9.jpg";